import resolveEnv, { DEV, launchDarklyClientSideId } from '@fluentsms/utils';
import { ProviderConfig } from 'launchdarkly-react-client-sdk';

export const environment = resolveEnv();
export const clientSideID = launchDarklyClientSideId[environment];

export const launchDarklyConfig: ProviderConfig = {
  clientSideID,
  options: {
    bootstrap: 'localStorage',
  },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  deferInitialization: false,
};

/**
 * FEATURE FLAG NAMING CONVENTION:
 * Ensure that feature flag names are valid in form of: documents-1789856-abc123-def456
 *
 * WHERE:
 *   documents = owner of the feature flag
 *   1789856 = ticket id of the feature flag
 *   abc123-def456 = kabob case description of the feature flag
 *
 */
export const validateFeatureFlagName = (name: string) => {
  const isValid = /^[a-z]+-\d{6,8}(-[a-z0-9]+)+$/.test(name);
  const errorMessage = `Invalid feature flag name: ${name}`;

  if (!isValid) {
    console.warn(errorMessage);
    if (environment === DEV) throw new Error(errorMessage);
  }
};
